import React from "react";

import {
  ensureCallPilotChatbotReady,
  openCallPilotChatbot,
} from "../helpers/callPilotChatbot";

const SupportEmailLink = ({
  email,
  target = null,
  text,
  className,
  sx,
  openChat = false,
}) => {
  if (openChat) {
    return (
      <button
        type="button"
        onClick={() => {
          void ensureCallPilotChatbotReady({ hideLauncher: true }).then(() => {
            openCallPilotChatbot();
          });
        }}
        className={className}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          font: "inherit",
          textAlign: "inherit",
          ...sx,
        }}
      >
        {text}
      </button>
    );
  }

  return (
    <a
      href={`mailto:${email}`}
      target={target}
      className={className}
      style={sx}
    >
      {text}
    </a>
  );
};

export default SupportEmailLink;
